import { render, staticRenderFns } from "./Adb2c.vue?vue&type=template&id=97665606&"
import script from "./Adb2c.vue?vue&type=script&lang=js&"
export * from "./Adb2c.vue?vue&type=script&lang=js&"
import style0 from "./Adb2c.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports